import { AbsenceDayLimitPoolDto } from 'src/app/models/dtos/absence-subtype-dto';
import { WorkingTimePeriodDto } from 'src/app/models/dtos/absences/working-time-periods-dto';
import { AbsenceLimitScalingStrategyEnum } from 'src/app/models/enums/absence-limit-scaling-strategy-enum';
import { isPartTimePeriod } from './working-time-periods';

// Keep in sync with backend AbsenceLimitScalingPolicy.ScaleByWorkingTimeFraction (duplicated intentionally for calendar range calculation).
const scaleNominalDayLimit = (nominalDaysLeft: number, period: WorkingTimePeriodDto | null): number =>
  isPartTimePeriod(period) ? Math.floor((nominalDaysLeft * period.Denominator) / period.Nominator) : nominalDaysLeft;

/**
 * Days available for a daily request in the working time period of the request date: minimum over the limit pools,
 * where only pools scaled by working time are converted from nominal (8h) days. Older responses carry only a scalar limit.
 */
export function scaleDayLimit(
  limit: number | null | undefined,
  pools: AbsenceDayLimitPoolDto[] | null | undefined,
  period: WorkingTimePeriodDto | null,
  strategy: AbsenceLimitScalingStrategyEnum | null | undefined,
): number | null {
  if (pools != null) {
    return pools.length
      ? Math.min(...pools.map((pool) => (pool.IsScaled ? scaleNominalDayLimit(pool.LimitLeft, period) : pool.LimitLeft)))
      : 0;
  }

  if (strategy !== AbsenceLimitScalingStrategyEnum.ScaleByWorkingTimeFractionFloor) {
    return limit ?? null;
  }

  return limit == null ? null : scaleNominalDayLimit(limit, period);
}
